import Stack from '@mui/material/Stack'

import { CancelButton, SaveButton } from '../../../../global/Button'
import ActionBar from '../../../../global/Widget/ActionBar'
import { IPermission } from '../../../../../compiler/global.interface'
import { FieldValues, useFieldArray, UseFormReturn } from 'react-hook-form'
import { useSettingAccessUserGroupPageContext } from '../../../../../pages/Setting/Access/UserGroup'
import { useEditGroupPermissionByUUID } from '../../../../../hook/query/groupCRUD'
import { useSnackbar } from 'notistack'
import { EHelperText } from '../../../../../utilitie/validation'
import { getEntireFormStyle } from '../../../../global/EntireForm'
import HierarchicalPermissionTable from '../HierarchicalPermissionTable'


export interface IUserGroupAccessManageProps {
  usePermissionForm: UseFormReturn<{ permissionData: IPermission[] }, object>
}


export default function UserGroupAccessManage({ usePermissionForm }: IUserGroupAccessManageProps) {

  const { enqueueSnackbar } = useSnackbar()

  const { uuid, defaultValues } = useSettingAccessUserGroupPageContext()

  const { control, reset, handleSubmit, setValue, getValues } = usePermissionForm

  const permissionFields = useFieldArray({ control, name: 'permissionData' })

  const { mutateAsync: editGroupPermission, isLoading: editGroupPermissionLoading } = useEditGroupPermissionByUUID(uuid || '')

  const _handleSubmit = async (values: FieldValues) => {
    await editGroupPermission(values as { permissionData: IPermission[] }).then(data => {
      enqueueSnackbar(EHelperText.UPDATED_SUCCESS, { variant: 'success' })
    }).catch(error => {
      reset(defaultValues.usePermissionForm)
      enqueueSnackbar(EHelperText.UPDATED_ERROR, { variant: 'error' })
    })
  }

  const handleCancel = () => {
    reset(defaultValues.usePermissionForm)
  }

  const isReadyToAction = !editGroupPermissionLoading && !defaultValues.useInfoForm.is_master

  return (
    <Stack height={'100%'} component="form" onSubmit={handleSubmit(_handleSubmit, error => console.error(error))} sx={{ ...getEntireFormStyle(!!defaultValues.useInfoForm?.is_master) }}>
      <HierarchicalPermissionTable
        control={control}
        setValue={setValue}
        getValues={getValues}
        permissionFields={permissionFields.fields}
        replaceFields={permissionFields.replace}
      />
      <ActionBar>
        <CancelButton disabled={!isReadyToAction} onClick={handleCancel} >ยกเลิก</CancelButton>
        <SaveButton type="submit" disabled={!isReadyToAction} >บันทึก</SaveButton>
      </ActionBar>
    </Stack>
  );
}
